import type { AuthUser } from '@offer/auth-lib'
import { useEffect, useSyncExternalStore } from 'react'
import { useLocation } from 'react-router'
import {
  clearAnalyticsIdentity,
  getAnalyticsIdentityUserId,
  setAnalyticsIdentity,
  subscribeToAnalyticsIdentity,
  trackAnalyticsEvent,
} from '@/services/analytics'

const START_SESSION_TRACKED_KEY = 'offer_catalog.start_session_tracked'

export function useAmplitude(user: AuthUser | null, isAuthenticated: boolean) {
  const location = useLocation()
  const identifiedUserId = useSyncExternalStore(
    subscribeToAnalyticsIdentity,
    getAnalyticsIdentityUserId,
    () => null,
  )
  const userId = user?.id
  const userName = user?.name ?? ''
  const userJob = user?.job

  useEffect(() => {
    if (!isAuthenticated || !userId) {
      clearAnalyticsIdentity()
      return
    }

    setAnalyticsIdentity({ id: userId, name: userName, job: userJob })

    const sessionKey = `${START_SESSION_TRACKED_KEY}.${userId}`
    if (!window.sessionStorage.getItem(sessionKey)) {
      trackAnalyticsEvent('Start Session')
      window.sessionStorage.setItem(sessionKey, 'true')
    }
  }, [isAuthenticated, userId, userName, userJob])

  const isAnalyticsReady = Boolean(isAuthenticated && userId && identifiedUserId === userId)

  useEffect(() => {
    if (!isAnalyticsReady)
      return

    trackAnalyticsEvent('page_viewed', {
      page_path: location.pathname,
      page_search: location.search,
      page_hash: location.hash,
      page_title: document.title,
    })
  }, [isAnalyticsReady, location.pathname, location.search, location.hash])
}
